import { render } from "./PasswordResetList.vue?vue&type=template&id=53b2892e"
import script from "./PasswordResetList.vue?vue&type=script&lang=js"
export * from "./PasswordResetList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__